import { render, staticRenderFns } from "./DashboardOptions.vue?vue&type=template&id=506bd57b&scoped=true&"
import script from "./DashboardOptions.vue?vue&type=script&lang=js&"
export * from "./DashboardOptions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOptions.vue?vue&type=style&index=0&id=506bd57b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bd57b",
  null
  
)

export default component.exports